// cpb-add-to-cart-button

//react-tabs__tab-list
//react-tabs__tab

//cpb-next-tab-button
//cpb-prev-tab-button

var tab1 = 'react-tabs-0';
var tab2 = 'react-tabs-2';
var tab3 = 'react-tabs-4';
var tab4 = 'react-tabs-6';
var tab5 = 'react-tabs-8';
var tab6 = 'react-tabs-10';
var tab7 = 'react-tabs-12';

//var nextButton = $('.cpb-next-tab-button ');
var nextButton = $('.cpb-product-actions').children().eq(1).children().eq(0).children().eq(1);
var prevButton = $('.cpb-prev-tab-button');
var addToCartButton = $('.cpb-add-to-cart-button');
//var pPrice = $('.cpb-product-price > span');
var pPrice = $('.cpb-product-price');
var categoryTitle= $('.cpb-category-title');
var summary = $('.cpb-selection-summary');


nextButton.attr('id','nextButton');
prevButton.attr('id','prevButton');

nextButton.find('span').text('Weiter');
prevButton.find('span').text('Zurück');
$('#' + tab4).text('Zusammenfassung');

pPrice.after('<p class="delivery">Die Produktion und Lieferung Deines persönlich angefertigten Hemdes dauert ca. 3-4 Wochen.</p>');
pPrice.before(`<p id="pSelected" class="selected">Ausgewähltes Stoffmuster: Bügelfreies Popeline-Hemd, weiss, 100% Baumwolle</p>`);
summary.before(`<p id="pSummaryDescription" class="selected">Hier findest Du eine Zusammenfassung Deiner gewählten Personalisierungsoptionen. Bitte prüfe nochmals deren Richtigkeit, bevor Du den Auftrag abschickst und teile uns mit, wieviel Stück Du gerne bestellen möchstest. Falls Du noch Anmerkungen oder Wünsche hast, dann teile uns diese hier mit.</p>`);

var pSelect = $('#pSelected');

pSelect.after(`<a id="measurements-link" href="https://manilohemden.ch/pages/pflegeanleitungen-manilo-hemden" class="selected">Pflegeanleitungen</a></br>`);


$('.cpb-panels-container').click((e) => {
e.preventDefault();
   const activeTab = $('.react-tabs__tab.cpb-active');
   //Image selected on click
   if(e.target){
     if(e.target.alt && e.target.className.indexOf('img') !== -1 && activeTab.attr('id').indexOf(tab1) !== -1){
       $('#pSelected').text(`Ausgewähltes Stoffmuster: ${e.target.alt}`);
     }
     //Table link
     const id = e.target.id;
     if(id && id.indexOf('sizechart-table') !== -1){
       window.open('https://manilohemden.ch/pages/size-chart');
     }
    
     if(id && id.indexOf('measurements-link') !== -1){
       window.open('https://manilohemden.ch/pages/pflegeanleitungen-manilo-hemden');
     }
   }
  
 });


/*
setTimeout(function(){
	p = $('.cpb-product-price');
  console.log(p);
  	let test = "CHF " + parseInt(p.text().split("CHF")[1]);
  	p.text(test);
  	console.log(test);
  	console.log("price 3rd:",p);
  nextButton.attr('id','nextButton');
  console.log("nextBtn", nextButton);
  console.log("btns parent:", $('.cpb-product-actions').children().eq(1).children().eq(0).children().eq(1));
}, 4000);
console.log("nextBtn", nextButton);
*/
function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
               // observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
};

waitForElm('.cpb-product-price').then((elm) => {
  setTimeout(function(){

  ($('.cpb-product-price')[0]).addEventListener('DOMSubtreeModified',(e) => {
     let p = $('#customElement');
     let priceElem = $('.cpb-product-price');
     let test = "CHF " + parseInt(priceElem.text().split("CHF")[1]);
     p.text(test);
     });
  }, 2000);
  
});


waitForElm('.cpb-option-label').then((elm) => {//new
  //react-tabs__tab-list
  $('div > div.cpb-panel-categories-container.col-tabs > div.cpb-category.cpb-category-img > div.cpb-category-content > .cpb-category-options-container.img > div').first().addClass( "first-product-section" );
 setTimeout(function(){

  ($('.react-tabs__tab-list')[0]).addEventListener('DOMSubtreeModified',(e) => {
    console.log("blaaa");
    waitForElm('div > div.cpb-panel-categories-container.col-tabs > div.cpb-category.cpb-category-img > div.cpb-category-content > .cpb-category-options-container.img > div').then((el) => {
       $('div > div.cpb-panel-categories-container.col-tabs > div.cpb-category.cpb-category-img > div.cpb-category-content > .cpb-category-options-container.img > div').first().addClass( "first-product-section" );
    })
   })
 }, 2000)
});

waitForElm('.row').then((e) => {
  /*
  let txt3 = document.createElement("div");
  let priceElem = $('.cpb-product-price');
  let test = "CHF " + parseInt(priceElem.text().split("CHF")[1]);
  txt3.innerHTML = test;
  txt3.setAttribute('id', 'customElement');
  txt3.setAttribute('class', 'customPriceEl');
  
  $('.row:first').before(txt3);
  */
  
  let txt4 = document.createElement("small");
  txt4.innerHTML = "Liefertermin: ca. 2-3 Wochen (die Lieferung ist kostenlos)";
  txt4.setAttribute('id','priceLabel');
  txt4.setAttribute('class','customPriceLabel light-gray');
  $('.cpb-product-price').after(txt4);
});

waitForElm('#react-tabs-12').then((elm) => {
  setTimeout(function(){

  ($('#react-tabs-12')[0]).addEventListener('DOMSubtreeModified',(e) => {
    let lastTabClassList = $('#react-tabs-12')[0].classList;
    let goToCartBtn = $('.cpb-add-to-cart-button');
    if(lastTabClassList.length > 1){
      goToCartBtn.css("display", "unset");
    }else{
      goToCartBtn.css("display", "none");
    }
     });
  }, 2000);
  
});




$('.react-tabs__tab').click((e) => {//react-tabs-6 8 10 12
e.preventDefault();
const selectedId = $(e.target).attr('id');
  
  
  if(selectedId.indexOf(tab3) !== -1){
    categoryTitle.show();
  }
  else 
    categoryTitle.hide();
  
  if(selectedId.indexOf(tab4) !== -1) {
    addToCartButton.show();
    $('#pSelected').hide();
  }
  else {
    addToCartButton.hide();
    nextButton.show();
    $('#pSelected').show();
  }
  
  if(selectedId.indexOf(tab1) !== -1){
    prevButton.hide();
  }
  else
  {
    prevButton.show();
  }
    
});

nextButton.click((e) => {
  e.preventDefault();
  const selectedId = $('.react-tabs__tab.cpb-active').attr('id');
  
  if(selectedId.indexOf(tab3) !== -1){
    nextButton.hide();
    prevButton.show();
    addToCartButton.show();
    $('#pSelected').hide();
  } else{
    addToCartButton.hide();
  }
  
  if(selectedId.indexOf(tab1) !== -1){
    prevButton.show();
  }
  
});

prevButton.click((e) => {
  e.preventDefault();
  const selectedId = $('.react-tabs__tab.cpb-active').attr('id');
  
  if(selectedId.indexOf(tab2) !== -1){
    nextButton.show();
    prevButton.hide();
  } else {
    nextButton.show();
    prevButton.show();
   }
    
  addToCartButton.hide();
  $('#pSelected').show();
});



;($ => {  
  function renameViewButtons() {
    const buttonNames = {
      'Vorderseite': 'Gesamtansicht',
      'Unterseite': 'Detailansicht'
    }
    rename()

    let timeout
    let timeout2
    window.addEventListener('resize', function() {
      clearTimeout(timeout)
      clearTimeout(timeout2)
      timeout = setTimeout(rename, 1000)
      timeout2 = setTimeout(rename, 3000)
    })

    function rename() {
      $('.Polaris-Button').each(function() {
        const button = $(this)
        const span = button.find('span > span')
        if(buttonNames[span.text()]) span.text(buttonNames[span.text()])
      })
    }
  }

  function panelIndexes() {
    const builder = $('#product-builder')
    const tabList = $('.cpb-panels-container .react-tabs__tab-list')
    update()
    document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', update)
    document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', update)

    function update() {
      const tabs = tabList.find('.react-tabs__tab')
      let active = 0
      tabs.each(function(i) {
        if($(this).hasClass('cpb-active')) active = i
      })
      builder.attr('data-cpb-custom-active-tab', active)
      builder.attr('data-cpb-custom-active-tab-from-end', tabs.length - 1 - active)
    }
  }

  const previewZoom = {
    zoomRatio: 3,
    
    previewContainer: false,
    currentView: false,
    zoom: {wrapper: false, img: false},
    size: {w: false, h: false},    
    init() {
      this.previewContainer = $('.cpb-preview-container')      
      this.setObserver(this.previewContainer[0])
      this.activateZoom()
    },
    setObserver(container) {
      const observer = new MutationObserver(function() {
        this.currentView = CPB.getStore().getState().App.settings.currentView
      }.bind(this))
      observer.observe(container, {attributes: true, childList: true, subtree: true})
      return observer
    },
    activateZoom() {
      const that = this
      this.zoom.wrapper = $('<div class="cpb-custom-preview-zoom">')
      this.zoom.img = $('<img class="cpb-custom-preview-zoom__image">').css('transform', 'scale(' + this.zoomRatio + ')')
      this.zoom.wrapper.append(this.zoom.img)
      
      $(document).on('mouseenter', '.cpb-render-konva', function(e) {
        const convaContainer = $(this)
        that.size.w = convaContainer[0].clientWidth
        that.size.h = convaContainer[0].clientHeight
        that.zoom.img.attr('src', that.getViewImageURL(that.currentView, that.zoomRatio))
        convaContainer.append(that.zoom.wrapper)
      })
      $(document).on('mouseleave', '.cpb-render-konva', function(e) {
        that.zoom.wrapper.detach()
      })
      $(document).on('mousemove', '.cpb-render-konva', function(e) {
        const posX = 100 - (that.size.w - e.offsetX) / that.size.w * 100
        const posY = 100 - (that.size.h - e.offsetY) / that.size.h * 100
        that.zoom.img.css('transform-origin', posX + '%' + ' ' + posY + '%')
      })
    },
    getViewImageURL(view, ratio) {
      if(typeof window.cpbImageStorage === 'undefined') return
      const getDataURL = cpbImageStorage.views[view].getSnapshot(ratio)
      return getDataURL
    }
  }

  function choiceCategories() {
    const product = CPB.getStore().getState().Product
    update()
    document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', update)
    document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', update)
    
    function update() {
      $('.choice-categories--js:not([data-custom-choice-category-processed="true"])').each(function() {
        const category = $(this).attr('data-custom-choice-category-processed', true)
        const categoryId = category.attr('data-category-id')
        let categoryObj
        product.panels.find(panel => {
          categoryObj = panel.categories.find(category => category.id === categoryId)
          return categoryObj
        })
        
        category.find('.cpb-option-type-img').each(function() {
          const option = $(this)
          const optionId = option.attr('data-option-id')
          const optionObj = categoryObj.options.find(option => option.id === optionId)
          if(!optionObj.metafields) return
          const optionCategory = optionObj.metafields.find(metafield => metafield.key === 'choice-category')?.value
          if(!optionCategory) return
          const categoryNameEl = $(`<div class="cpb-custom-choice-category" data-custom-choice-category="${optionCategory}">`).html(`<span>${optionCategory}</span>`)
          option.before(categoryNameEl)
        })
      })
    }
  }

  function customRedirectToCart() {
    document.addEventListener('cpb-add-to-cart', () => {
      if(CPB.getStore().getState().App.settings.hasRedirectToCart === true) location.href = (window.Shopify.routes?.root || '/') + 'cart'      
    })
  }

  function linksLanguageBasedRedirect() {
    rewriteLinks()
    document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', rewriteLinks)
    document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', rewriteLinks)
    
    $(document).on('click', '.cpb-category-desc a:not([data-custom-language-edited="true"])', e => {
      e.preventDefault()      
      let href = $(e.target).attr('href')
      href = href.replace(location.origin, '')      
      if(href[0] !== '/') {
        location.href = href
        return
      }      
      const root = (window.Shopify.routes?.root || '/')      
      if(href.substring(0, root.length) === root) {
        location.href = href
        return
      }      
      location.href = root + href.substring(1)
    })

    function rewriteLinks() {
      $('.cpb-category-desc a:not([data-custom-language-edited="true"])').each(function() {
        const link = $(this).attr('data-custom-language-edited', true)
        let href = link.attr('href')
        let hasOrigin = false        
        if(href.indexOf(location.origin) === 0) {
          hasOrigin = true
          href = href.replace(location.origin, '')
        }        
        if(href[0] !== '/') return        
        const root = (window.Shopify.routes?.root || '/')        
        if(href.substring(0, root.length) === root) return
        const fixedPath = root + href.substring(1)
        link.attr('href', hasOrigin ? location.origin + fixedPath : fixedPath) 
      })
    }
  }

  function wrapSummaryOptionNames() {
    document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', update)
    
    function update() {
      $('.cpb-selection-summary-list-item-category-value').each(function() {
        const item = $(this)
        const splitted = item.text().split(' - ')
        if(splitted.length === 1) return
        item.html(`<span>${splitted[0]}</span> - ${splitted[1]}`)
      })
    }
  }
  
  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', () => {
    renameViewButtons()
    panelIndexes()
    previewZoom.init()
    choiceCategories()
    customRedirectToCart()
    linksLanguageBasedRedirect()
    wrapSummaryOptionNames()
  })
})(jQuery)




 

